/* eslint-disable import/prefer-default-export */
export const LOAD_TRANSFER_FILES = 'LOAD_TRANSFER_FILES';
export const TOGGLE_FETCHING_STATE = 'TOGGLE_FETCHING_STATE';
export const LOAD_PROJECT_DETAILS = 'LOAD_PROJECT_DETAILS';
